import AdminEleven from "@/layouts/AdminEleven.vue";

export const marketingRoutes = [
  // ---- Marketing ---- //
  {
    path: "/marketing",
    component: AdminEleven,
    props: {
      withSearchInput: false,
    },
    children: [
      {
        name: "marketing",
        path: "configuracoes",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/marketing/Marketing.vue"
          ),
        meta: {
          title: "Marketing",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "invitation",
        path: "convite",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/marketing/Invitation.vue"
          ),
        meta: {
          title: "Convite",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "inviteResume",
        path: "convite/listar/:id",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/components/marketing/invitation/InviteResume.vue"
          ),
        meta: {
          title: "Listar Convite",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "inviteForm",
        path: "convite/cadastrar/:id",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/components/marketing/invitation/form/InviteForm.vue"
          ),
        meta: {
          title: "Cadastrar Convite",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "InviteFormEdit",
        path: "convite/editar/:id",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/components/marketing/invitation/form/Edit.vue"
          ),
        meta: {
          title: "Cadastrar Convite",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
    ],
  },
];
